<template>
  <aside class="rui-alert" :class="componentCSS">
    <img v-if="image" :src="image" alt="" class="rui-alert__picture">
    <div :class="centered && '-text--center'"><slot>{{ content }}</slot></div>
  </aside>
</template>

<script>
const variants = ['info', 'success', 'danger', 'warning', 'mute']

/**
 * This component should be used to display important piece of information.
 *
 * @preset Default { "props": { "variant": "info" }, "slots": { "default": "You can change the props to modify the behavior"} }
 * @propsGroup Display [centered, variant]
 * @propsGroup Content [image, content]
 */
export default {
  name: 'RuiAlert',
  props: {
    /**
     * Color variant
     *
     * @values info, success, danger, warning, mute
     */
    variant: { required: false, type: String, default: null, validator: v => variants.includes(v) },
    /** URL to a side image */
    image: { required: false, type: String, default: null },
    /** Whether to center the content */
    centered: { required: false, type: Boolean, default: false },
    /** Text. Will be overridden by default slot content */
    content: { required: false, type: String, default: null },
  },
  computed: {
    componentCSS () {
      return [
        this.variant && `rui-alert--${this.variant}`,
        this.image && 'rui-alert--with-picture',
      ]
    },
  },
}
</script>
